const ApplyPromoIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_941_869)">
			<path
				d="M14.168 2.78357C15.4249 3.50928 16.4704 4.55067 17.2011 5.80465C17.9319 7.05863 18.3224 8.48171 18.3342 9.93302C18.3459 11.3843 17.9784 12.8135 17.268 14.0792C16.5576 15.3448 15.529 16.4029 14.284 17.1488C13.039 17.8948 11.6208 18.3026 10.1697 18.332C8.71866 18.3613 7.28509 18.0112 6.01093 17.3163C4.73677 16.6213 3.66619 15.6057 2.90519 14.3698C2.14419 13.134 1.71914 11.7208 1.67214 10.2702L1.66797 10.0002L1.67214 9.73024C1.7188 8.29106 2.13759 6.88854 2.88767 5.6594C3.63774 4.43026 4.69351 3.41645 5.95205 2.7168C7.21058 2.01716 8.62892 1.65557 10.0688 1.66727C11.5087 1.67897 12.921 2.06357 14.168 2.78357ZM13.0905 7.7444C12.947 7.60092 12.7561 7.51473 12.5535 7.502C12.351 7.48926 12.1508 7.55086 11.9905 7.67524L11.9121 7.7444L9.16797 10.4877L8.09047 9.41107L8.01214 9.3419C7.85179 9.21762 7.65161 9.15609 7.44914 9.16886C7.24667 9.18164 7.05581 9.26783 6.91235 9.41129C6.7689 9.55474 6.6827 9.7456 6.66993 9.94807C6.65716 10.1505 6.71868 10.3507 6.84297 10.5111L6.91214 10.5894L8.5788 12.2561L8.65714 12.3252C8.80328 12.4386 8.983 12.5002 9.16797 12.5002C9.35294 12.5002 9.53266 12.4386 9.6788 12.3252L9.75714 12.2561L13.0905 8.92274L13.1596 8.8444C13.284 8.68407 13.3456 8.48386 13.3329 8.28133C13.3201 8.07881 13.2339 7.8879 13.0905 7.7444Z"
				fill="#2FBF4E"
			/>
		</g>
		<defs>
			<clipPath id="clip0_941_869">
				<rect
					width="20"
					height="20"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
);

export default ApplyPromoIcon;
